const validate = binding => {
  if (typeof binding.value !== 'function') {
    console.warn('[Vue-end-reached:] provided expression', binding.expression, 'is not a function.');
    return false;
  }
  return true;
}

const isServer = vNode => {
  return typeof vNode.componentInstance !== 'undefined' && vNode.componentInstance.$isServer
}

export default {
  bind: (el, binding, vNode) => {
    if (!validate(binding) || isServer(vNode)) return;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.isIntersecting
          && entry.boundingClientRect.y > 150 // появление с нижнего края
          && el.__vueReached__.callback()
        ;
      })
    });

    observer.observe(el);

    el.__vueReached__ = {
      observer,
      callback: binding.value
    }
  },

  update: (el, binding) => {
    if (validate(binding)) el.__vueReached__.callback = binding.value
  },

  unbind: (el, binding, vNode) => {
    if (!isServer(vNode) && el.__vueReached__) {
      el.__vueReached__.observer.unobserve(el);
      delete el.__vueReached__;
    }
  }
}
